import * as Uom from '@/services/rest-api/lib/product/unit-of-measurement'

const uomConversionFields = [
  {
    key: 'conversionAmount',
    label: 'Jumlah',
  },
  {
    isEditable: true,
    key: 'name',
    name: 'name',
    label: 'Satuan Konversi',
    placeholder: 'Pack',
    type: 'select-resourceful',
    trackBy: 'name',
    optionsGetter: Uom.get,
    initialObjectKey: 'name',
    optionLabelFn: ({ item }) => item.name,
    validation: 'bail|required',
    thStyle: 'width: 250px',
  },
  {
    key: 'equal',
    label: '',
  },
  {
    isEditable: true,
    key: 'amount',
    name: 'amount',
    label: 'Jumlah',
    placeholder: '24',
    _type: 'number',
    validation: 'bail|required|number|max:1000000,value|not:0',
    'validation-messages': {
      number: 'Harus berupa angka',
      max: 'Maksimal 1,000,000',
      not: 'Harus lebih dari 0',
    },
    thStyle: 'width: 250px',
  },
  {
    key: 'base_uom',
    label: 'Satuan Dasar',
    tooltip: 'Satuan dasar merupakan satuan terkecil dari produk Anda.',
    thStyle: 'width: 250px',
  },
  {
    isEditable: true,
    key: 'weight',
    name: 'weight',
    label: 'Berat Konversi',
    placeholder: 'Berat Konversi',
    _type: 'number',
    validation: 'bail|number|max:1000000,value|not:0',
    'validation-messages': {
      number: 'Harus berupa angka',
      max: 'Maksimal 1,000,000',
      not: 'Harus lebih dari 0',
    },
    thStyle: 'width: 250px',
  },
  {
    isEditable: true,
    key: 'volume',
    name: 'volume',
    label: 'Volume Konversi',
    placeholder: 'Volume Konversi',
    _type: 'number',
    validation: 'bail|number|max:1000000,value|not:0',
    'validation-messages': {
      number: 'Harus berupa angka',
      max: 'Maksimal 1,000,000',
      not: 'Harus lebih dari 0',
    },
    thStyle: 'width: 250px',
  },
  {
    isEditable: true,
    key: 'price',
    name: 'price',
    label: 'Harga Konversi (Rp)',
    placeholder: 'Harga Konversi',
    _type: 'number',
    validation: 'bail|number|max:1000000000000,value|not:0',
    'validation-messages': {
      number: 'Harus berupa angka',
      max: 'Maksimal Rp. 1.000.000.000.000',
      not: 'Minimal Rp. 1',
    },
    thStyle: 'width: 250px',
  },
]

export default uomConversionFields
